document.addEventListener("DOMContentLoaded", () => {

  // Remover a divPaiTamanhos do produto
  function removeDivSize(product) {
    const divPai = product.querySelector(".divPaiTamanhos");
    if (divPai) {
      divPai.remove(); // Remoção direta da divPai
    }
  }
  
  // Obter os tamanhos do produto
  async function getSizesProduct(product) {
      const linkDiv = product.children[0].children[0];
      const url = linkDiv.getAttribute("href");
      const sizes = await getSizesJson(url);

      // Verifica se a divPai já foi inserida, para não duplicar
      if (product.querySelector(".divPaiTamanhos")) {
        return;
      }

      const divPai = document.createElement("div");
      divPai.classList.add("divPaiTamanhos");

      sizes.forEach((size) => {
        const divSize = document.createElement("div");
        divSize.classList.add("containerBlockSizes");
        const titleSize = document.createElement("p");
        titleSize.classList.add("containerSize");
        titleSize.innerText = `${size.name}: `;
        divSize.append(titleSize);

        size.values.forEach((tam) => {
          let tamanhoDiv = document.createElement("button");
          tamanhoDiv.innerText = tam;
          divSize.appendChild(tamanhoDiv);
        });

        divPai.append(divSize);
      });

      // Certifique-se de adicionar a divPai apenas uma vez
      product.children[0].append(divPai);
  }

  // Buscar os dados dos tamanhos do produto
  async function getSizesJson(url) {
    const response = await fetch(`https://movie.fitness/${url}.json`).then((res) => res.json());
    const product = response.product.options;
    const productFilter = product.filter((p) => p.name.split(" ")[0] === "Size");
    return productFilter;
  }
  
  const listProducts = document.querySelectorAll('.prod-container');
  
  // Adiciona os eventos para mouseenter e mouseleave
  listProducts.forEach((product) => {
    // Evento para quando o mouse entra no produto
    product.addEventListener("mouseenter", () => getSizesProduct(product));

    // Evento para quando o mouse sai do produto
    product.addEventListener("mouseleave", () => removeDivSize(product));
  });
  
});
